import styled from 'styled-components'
import { Button, Row, Col, Input, ProTableOt, setParamsFilter, Form, Select, SelectCombo, toast, Toaster } from "./../../../ui/ot"

import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from "../../../ui/dropdown-menu"
import { Link, useNavigate, useParams } from 'react-router-dom'

import MultipleSelector from '../../../ui/multiple-selector'
import { useItem } from '../../controllers/ItemController'
import { useRef } from 'react'
import { useProTableOt } from './../../../utility/componentOt/controllers/ProtableOtController'
import { useEffect } from 'react'
import { useLibrary } from '../../controllers/LibraryController'

const ListItems = () => {
    const { bib_biblionumber, item_itemnumber } = useParams()
    const navigate = useNavigate()
    const [form] = Form.useForm()
    const mode = item_itemnumber ? 'patch' : 'post'
    const actionRef = useRef()
    const columns = [
        {
            title: '',
            dataIndex: 'action',
            key: 'action',
            render: (text, record) => (
                <DropdownMenu>
                    <DropdownMenuTrigger><Button variant="outline" >功能</Button></DropdownMenuTrigger>
                    <DropdownMenuContent>
                        <Link to={"/library/backstage/AddItem/" + bib_biblionumber + "/" + record?.item_itemnumber}>
                            <DropdownMenuItem>
                                編輯
                            </DropdownMenuItem>
                        </Link>
                        <DropdownMenuItem>複製</DropdownMenuItem>
                        <DropdownMenuItem>印製標籤</DropdownMenuItem>
                        <DropdownMenuItem onClick={() => deleteItemData(
                            [
                                {
                                    itemnumber: record?.item_itemnumber
                                }
                            ]
                        )}>刪除</DropdownMenuItem>
                    </DropdownMenuContent>
                </DropdownMenu>
            )

        },
        {
            title: '分類法來源或上架方式',
            dataIndex: 'class',
            key: 'class',
        },
        {
            title: '所屬圖書館',
            dataIndex: 'item_branchname',
            key: 'item_branchname',
        },
        {
            title: '當前圖書館',
            dataIndex: 'current_library',
            key: 'current_library',
            render: (text, record) => <>{record?.item_branchname}</>
        },
        {
            title: '購入日期',
            dataIndex: 'date_acquired',
            key: 'date_acquired',
        },
        {
            title: '借閱總次數',
            dataIndex: 'total_checkouts',
            key: 'total_checkouts',
        },
        {
            title: '續借總次數',
            dataIndex: 'total_renewals',
            key: 'total_renewals',
        },
        {
            title: '索書號',
            dataIndex: 'item_itemcallnumber',
            key: 'item_itemcallnumber',
        },
        {
            title: 'Barcode',
            dataIndex: 'item_barcode',
            key: 'item_barcode',
        },
        {
            title: '最後編輯日期',
            dataIndex: 'date_last_seen',
            key: 'date_last_seen',
        },
        {
            title: '最後借出日期',
            dataIndex: 'item_datelastborrowed',
            key: 'item_datelastborrowed',
        },
        {
            title: '副本數',
            dataIndex: 'item_copynumber',
            key: 'item_copynumber',
        },
        {
            title: '價格生效日期',
            dataIndex: 'price_effective_from',
            key: 'price_effective_from',
        },
        {
            title: '項目類型',
            dataIndex: 'item_itype_description',
            key: 'item_itype_description',
        },
    ]
    const onFormFinish = () => {
        const value = form.getValues();
        if (mode === "post") {
            postItemData([value])
        } else if (mode === "patch") {
            patchItemData([value])
        }
    }


    const {
        ItemData,
        getItemData,
        postItemData,
        patchItemData,
        deleteItemData,
    } = useItem({
        onBefore: () => { },
        onFinish: ({ axiosMode, status }) => {
            let action = ''
            let result = ''
            if (['post', 'patch', 'delete'].includes(axiosMode)) {
                if (axiosMode === "post") {
                    action = '新增'
                } else if (axiosMode === "post") {
                    action = '修改'
                } else if (axiosMode === "delete") {
                    action = '刪除'
                }
                if (status === "success") {
                    result = '成功'
                    toast.success(action + result)
                    actionRef.current.reloadAndRest()
                } else {
                    result = '失敗'
                    toast.error(action + result)
                }
            }
        }
    })
    const {
        check,
        setCheck,
        checkAll,
        setOrders,
        custom_filter_key,
        transferColumnAntdToShadcn,
        transferSortAntdToShadcn
    } = useProTableOt({
        columns
    })
    useEffect(() => {
        if (item_itemnumber) {
            Object.entries(ItemData?.find(_ => true) || {})?.forEach(([key, value]) => form.setValue(key, value))
            form.setValue('itemnumber', item_itemnumber)
        }
        form.setValue('biblionumber', bib_biblionumber)
    }, [ItemData, item_itemnumber])

    return (
        <MainContainer>
            <Toaster />
            <Row className='mb-5'>
                <Title>
                    館藏書籍：{ItemData?.find(_ => true)?.bib_title} 作者：{ItemData?.find(_ => true)?.bib_author}(Record #{ItemData?.find(_ => true)?.bib_biblionumber})
                </Title>
            </Row>
            <WhiteBox>
                <ProTableOt
                    actionRef={actionRef}
                    columns={columns}
                    request={async (params = {}, sort, filter) => {
                        // setAxiosMode("get")
                        let newParams = {
                        };
                        let order = setOrders(sort)
                        newParams = {
                            // ...params, //只有這個範例要有，其他請看你的後端要什麼資料
                            ...newParams,
                            order,
                            size: params.pageSize,
                            cur_page: params.current,
                            custom_filter_value: params.keyword ?? "",
                            keyword: params.keyword ?? "",
                            custom_filter_key: custom_filter_key,
                            // "categorycode": "TEST",
                            "field": "keyword",
                        };
                        newParams = setParamsFilter({
                            ...newParams,
                        });
                        // setPageSize(params?.pageSize ?? 20)
                        return getItemData({
                            biblionumber: bib_biblionumber,
                            ...newParams
                        })
                    }}

                    toolBarRender={() => {
                        return ([])
                    }}
                />
            </WhiteBox>
            <WhiteBox>
                <Row className='mb-5'>
                    {mode === 'patch' && <>
                        <Row className='mb-5'>
                            <Title>
                                修改館藏
                            </Title>
                        </Row>
                    </>}
                    {mode === 'post' && <>
                        <Row className='mb-5'>
                            <Title>
                                新增館藏
                            </Title>
                        </Row>
                    </>}
                </Row>
                <Row>
                    <Col span={24}>
                        <Form form={form} onFinish={onFormFinish}>
                            <ItemRecord
                                item_itemnumber={item_itemnumber}
                                form={form}
                            />
                            {mode === "patch" && <>
                                <ButtonGroup classnName='mt-4'>
                                    <Button onClick={() => form.submit()}>儲存變更</Button>
                                    <Button onClick={() => navigate('/library/backstage/additem/' + bib_biblionumber)}>新增項目</Button>
                                    <Button variant="outline" onClick={() => navigate(`/library/backstage/BookDetail?bib_biblionumber=${bib_biblionumber}`   )} >取消</Button>
                                </ButtonGroup>
                            </>}
                            {mode === "post" && <>
                                <ButtonGroup classnName='mt-4'>
                                    <Button onClick={() => form.submit()}>新增項目</Button>
                                    <Button>新增和複製項目</Button>
                                    <Button variant="outline" >新增複數項目</Button>
                                    <Button variant="outline" >儲存成範本</Button>
                                </ButtonGroup>
                            </>}
                        </Form>
                    </Col>
                </Row>


                {/* <WhiteBox>
                    <SubTitle>a - Home library</SubTitle>
                    <Em20>
                        <Select>
                            <SelectTrigger>
                                <SelectValue />
                            </SelectTrigger>
                            <SelectContent>
                                <SelectItem value="0">本館</SelectItem>
                                <SelectItem value="1">分館</SelectItem>
                            </SelectContent>
                        </Select>
                    </Em20>
                    <SubTitle>b - Current library</SubTitle>
                    <Em20>
                        <Select>
                            <SelectTrigger>
                                <SelectValue />
                            </SelectTrigger>
                            <SelectContent>
                                <SelectItem value="0">本館</SelectItem>
                                <SelectItem value="1">分館</SelectItem>
                            </SelectContent>
                        </Select>
                    </Em20>
                    <SubTitle>y - Koha item type</SubTitle>
                    <Em20>
                        <Select>
                            <SelectTrigger>
                                <SelectValue />
                            </SelectTrigger>
                            <SelectContent>
                                <SelectItem value="0">type 1</SelectItem>
                                <SelectItem value="1">type 2</SelectItem>
                            </SelectContent>
                        </Select>
                    </Em20>
                </WhiteBox>
                <ButtonGroup>
                    <Button>新增項目</Button>
                    <Button>新增和複製項目</Button>
                    <Button variant="outline" >新增複數項目</Button>
                    <Button variant="outline" >儲存成範本</Button>
                </ButtonGroup> 
                */}
            </WhiteBox>
        </MainContainer>
    )
}
const ItemRecord = ({
    item_itemnumber = 0,
    form
}) => {
    const {
        ItemData,
        getItemData,
    } = useItem({
        onBefore: () => { },
        onFinish: () => { }
    })

    const {
        LibraryData,
        getLibraryData,
    } = useLibrary({
        onBefore: () => { },
        onFinish: () => { }
    })

    useEffect(() => {
        const mergedItem = {
            "bib_biblionumber": "biblionumber",
            "item_barcode": "barcode",
            "item_acquisition_date": "acquisition_date",
            "item_bookable": "bookable",
            "item_branchcode": "home_library_id",
            "item_notforloan": "not_for_loan_status",
            "item_itemlost": "lost_status",
            "item_damaged": "withdrawn",
            "item_damaged": "damaged_status",
            "item_itemcallnumber": "callnumber",
            "item_location": "location",
            "item_itype": "item_type_id",
            "item_copynumber": "copy_number"
        };
        ItemData?.forEach(item => {
            Object.entries(item || {})?.forEach(([key, value]) => {
                if (mergedItem.hasOwnProperty(key)) {
                    form.setValue(mergedItem[key], value)
                }
            })
        })
    }, [ItemData])

    useEffect(() => {
        form.reset()
        getLibraryData()
        getItemData({
            itemnumber: item_itemnumber
        })
    }, [item_itemnumber])
    return <>
        <Row className='mb-2' gutter={[16, 16]} align={'middle'} >
            <Form.Item
                name={"biblionumber"}
                hidden
            >
                <Input />
            </Form.Item>
            <Form.Item
                name={"itemnumber"}
                hidden
            >
                <Input />
            </Form.Item>
            <Col span={24}>
                <Form.Item
                    label={"0 - Withdrawn status"}
                    name={"withdrawn"}
                >
                    <Input />
                </Form.Item>
            </Col>
        </Row>
        <Row className='mb-2' gutter={[16, 16]} align={'middle'} >
            <Col span={24}>
                <Form.Item
                    label={"2 - Source of classification or shelving scheme"}
                    name={"source_of_classification_or_shelving_scheme"}
                >
                    <Select
                        options={[
                            {
                                value: "Library of Congress Classification",
                            },
                            {
                                value: "Dewey Decimal Classification",
                            },
                        ]}
                    />
                </Form.Item>
            </Col>
        </Row>
        <Row className='mb-2' gutter={[16, 16]} align={'middle'} >
            <Col span={24}>
                <Form.Item
                    label={"3 - Materials specified (bound volume or other part)"}
                    name={"materials_specified"}
                >
                    <Input />
                </Form.Item>
            </Col>
        </Row>
        <Row className='mb-2' gutter={[16, 16]} align={'middle'} >
            <Col span={24}>
                <Form.Item
                    label={"4 - Damaged status"}
                    name={"damaged_status"}
                >
                    <Select
                        //value={value}
                        style={
                            {
                                minWidth: "200px"
                            }
                        }
                        onChange={(e) => { }}
                        options={[
                            // {
                            //     label: ,
                            //     value: ,
                            // }
                        ]}
                        placeholder="請選擇 ..."
                        creatable={false}
                        emptyIndicator={
                            <p className="text-center text-lg leading-10 text-gray-600 dark:text-gray-400">
                                No results found
                            </p>
                        }
                    />
                </Form.Item>
            </Col>
        </Row>
        <Row className='mb-2' gutter={[16, 16]} align={'middle'} >
            <Col span={24}>
                <Form.Item
                    label={"5 - Use restrictions"}
                    name={"restricted_status"}
                >
                    <Select
                        //value={value}
                        style={
                            {
                                minWidth: "200px"
                            }
                        }
                        onChange={(e) => { }}
                        options={[
                            // {
                            //     label: ,
                            //     value: ,
                            // }
                        ]}
                        placeholder="請選擇 ..."
                        creatable={false}
                        emptyIndicator={
                            <p className="text-center text-lg leading-10 text-gray-600 dark:text-gray-400">
                                No results found
                            </p>
                        }
                    />
                </Form.Item>
            </Col>
        </Row>
        <Row className='mb-2' gutter={[16, 16]} align={'middle'} >
            <Col span={24}>
                <Form.Item
                    label={"7 - Not for loan"}
                    name={"not_for_loan_status"}
                >
                    <Select
                        //value={value}
                        style={
                            {
                                minWidth: "200px"
                            }
                        }
                        onChange={(e) => { }}
                        options={[
                            // {
                            //     label: ,
                            //     value: ,
                            // }
                        ]}
                        placeholder="請選擇 ..."
                        creatable={false}
                        emptyIndicator={
                            <p className="text-center text-lg leading-10 text-gray-600 dark:text-gray-400">
                                No results found
                            </p>
                        }
                    />
                </Form.Item>
            </Col>
        </Row>
        <Row className='mb-2' gutter={[16, 16]} align={'middle'} >
            <Col span={24}>
                <Form.Item
                    label={"8 - Collection"}
                    name={"collection"}
                >
                    <Select
                        //value={value}
                        style={{
                            minWidth: "200px"
                        }}
                        onChange={(e) => { }}
                        options={[]}
                        placeholder="請選擇 ..."
                        creatable={false}
                        emptyIndicator={
                            <p className="text-center text-lg leading-10 text-gray-600 dark:text-gray-400">
                                No results found
                            </p>
                        }
                    />
                </Form.Item>
            </Col>
        </Row>
        <Row className='mb-2' gutter={[16, 16]} align={'middle'} >
            <Col span={24}>
                <Form.Item
                    label={<span className="text-right text-red-600">a - Home library</span>}
                    name={"home_library_id"}
                    rules={[
                        {
                            required: true,
                            message: "請輸入"
                        }
                    ]}
                >
                    <Select
                        style={
                            {
                                minWidth: "200px"
                            }
                        }
                        options={LibraryData.map((value) => {
                            return {
                                label: value?.branchname,
                                value: value?.branchcode,
                            }
                        })}
                        defaultValue={undefined}
                        placeholder="請選擇 ..."
                    />
                </Form.Item>
            </Col>
        </Row>
        <Row className='mb-2' gutter={[16, 16]} align={'middle'} >
            <Col span={24}>
                <Form.Item
                    label={<span className="text-right text-red-600">b - Current library</span>}
                    name={"current_library_id"}
                    rules={[
                        {
                            required: true,
                            message: "請輸入"
                        }
                    ]}
                >
                    <Select
                        style={
                            {
                                minWidth: "200px"
                            }
                        }
                        options={LibraryData.map((value) => {
                            return {
                                label: value?.branchname,
                                value: value?.branchcode,
                            }
                        })}
                        defaultValue={undefined}
                        placeholder="請選擇 ..."
                    />
                </Form.Item>
            </Col>
        </Row>
        <Row className='mb-2' gutter={[16, 16]} align={'middle'} >
            <Col span={24}>
                <Form.Item
                    label={<span className="text-right">c - Shelving location</span>}
                    name={"location"}
                >
                    <Select
                        //value={value}
                        style={{
                            minWidth: "200px"
                        }}
                        onChange={(e) => { }}
                        options={[
                            {
                                value: "二樓書庫區"
                            }
                        ]}
                        placeholder="請選擇 ..."
                        creatable={false}
                        emptyIndicator={
                            <p className="text-center text-lg leading-10 text-gray-600 dark:text-gray-400">
                                No results found
                            </p>
                        }
                    />
                </Form.Item>
            </Col>
        </Row>
        <Row className='mb-2' gutter={[16, 16]} align={'middle'} >
            <Col span={24}>
                <Form.Item
                    label={<span className="text-right">d - Date acquired</span>}
                    name={"acquisition_date"}
                >
                    <Input type='date' />
                </Form.Item>
            </Col>
        </Row>
        <Row className='mb-2' gutter={[16, 16]} align={'middle'} >
            <Col span={24}>
                <Form.Item
                    label={'e - Source of acquisition'}
                    name={"acquisition_source"}
                >
                    <Input />
                </Form.Item>
            </Col>
        </Row>
        <Row className='mb-2' gutter={[16, 16]} align={'middle'} >
            <Col span={24}>
                <Form.Item
                    label={'f - Coded location qualifier'}
                    name={"coded_location_qualifier"}
                >
                    <Input />
                </Form.Item>
            </Col>
        </Row>
        <Row className='mb-2' gutter={[16, 16]} align={'middle'} >
            <Col span={24}>
                <Form.Item
                    label={'g - Cost, normal purchase price'}
                    name={"purchase_price"}
                >
                    <Input />
                </Form.Item>
            </Col>
        </Row>

        <Row className='mb-2' gutter={[16, 16]} align={'middle'} >
            <Col span={24}>
                <Form.Item
                    label={'h - Serial enumeration / chronology'}
                    name={"serial_enumeration"}
                >
                    <Input />
                </Form.Item>
            </Col>
        </Row>
        <Row className='mb-2' gutter={[16, 16]} align={'middle'} >
            <Col span={24}>
                <Form.Item
                    label={'i - Inventory number'}
                    name={"inventory_number"}
                >
                    <Input />
                </Form.Item>
            </Col>
        </Row>
        <Row className='mb-2' gutter={[16, 16]} align={'middle'} >
            <Col span={24}>
                <Form.Item
                    label={'j - Shelving control number'}
                    name={"shelving_control_number"}
                >
                    <MultipleSelector
                        //value={value}
                        style={{
                            minWidth: "200px"
                        }}
                        onChange={(e) => { }}
                        options={[]}
                        placeholder="請選擇 ..."
                        creatable={false}
                        emptyIndicator={
                            <p className="text-center text-lg leading-10 text-gray-600 dark:text-gray-400">
                                No results found
                            </p>
                        }
                    />
                </Form.Item>
            </Col>
        </Row>
        <Row className='mb-2' gutter={[16, 16]} align={'middle'} >
            <Col span={24}>
                <Form.Item
                    label={<span className="text-right">o - Full call number</span>}
                    name={"callnumber"}
                >
                    <Input />
                </Form.Item>
            </Col>
        </Row>
        <Row className='mb-2' gutter={[16, 16]} align={'middle'} >
            <Col span={24}>
                <Form.Item
                    label={<span className="text-right text-red-600">p - Barcode</span>}
                    name={"barcode"}
                    rules={[
                        {
                            required: true,
                            message: "請輸入Barcode"
                        }
                    ]}
                >
                    <Input />
                </Form.Item>
            </Col>
        </Row>
        <Row className='mb-2' gutter={[16, 16]} align={'middle'} >
            <Col span={24}>
                <Form.Item
                    label={<span className="text-right">t - Copy number</span>}
                    name={"copy_number"}
                >
                    <Input />
                </Form.Item>
            </Col>

        </Row>
        <Row className='mb-2' gutter={[16, 16]} align={'middle'} >
            <Col span={24}>
                <Form.Item
                    label={<span className="text-right">u - Uniform resource identifier</span>}
                    name={"uri"}
                >
                    <Input />
                </Form.Item>
            </Col>
        </Row>
        <Row className='mb-2' gutter={[16, 16]} align={'middle'} >
            <Col span={24}>
                <Form.Item
                    label={<span className="text-right">v - Cost, replacement price</span>}
                    name={"replacement_price"}
                >
                    <Input />
                </Form.Item>
            </Col>
        </Row>
        <Row className='mb-2' gutter={[16, 16]} align={'middle'} >
            <Col span={24}>
                <Form.Item
                    label={<span className="text-right">w - Price effective from</span>}
                    name={"price_effective_date"}
                >
                    <Input type='date' />
                </Form.Item>
            </Col>
        </Row>
        <Row className='mb-2' gutter={[16, 16]} align={'middle'} >
            <Col span={24}>
                <Form.Item
                    label={<span className="text-right">x - Non-public note</span>}
                    name={"non_public_note"}
                >
                    <Input />
                </Form.Item>
            </Col>
        </Row>
        <Row className='mb-2' gutter={[16, 16]} align={'middle'} >
            <Col span={24}>
                <Form.Item
                    label={<span className="text-right text-red-600">y - item type</span>}
                    name={"item_type_id"}
                    rules={[
                        {
                            required: true,
                            message: "請選擇項目類型"
                        }
                    ]}
                >
                    <Select
                        //value={value}
                        style={{
                            minWidth: "200px"
                        }}
                        onChange={(e) => { }}
                        options={[
                            {
                                value: "PB",
                                label: "實體書"
                            },
                            {
                                value: "TEST",
                                label: "測試 itemtype"
                            },
                        ]}
                        placeholder="請選擇 ..."
                        creatable={false}
                        emptyIndicator={
                            <p className="text-center text-lg leading-10 text-gray-600 dark:text-gray-400">
                                No results found
                            </p>
                        }
                    />
                </Form.Item>
            </Col>
        </Row>
        <Row className='mb-4' gutter={[16, 16]} align={'middle'} >
            <Col span={24}>
                <Form.Item
                    label={<span className="text-right">z - Public note</span>}
                    name={"public_note"}
                >
                    <Input />
                </Form.Item>
            </Col>
        </Row>
    </>
}

const MainContainer = styled.div`
width: 100%;
display: flex;
-webkit-box-pack: center;
justify-content: space-around;
flex-direction: column;
-webkit-box-align: start;
align-items: start;
padding: 2em;
gap: 0.5em;
-webkit-flex-wrap: wrap;
`

const Title = styled.div`
text-align: left;
width: 100%;
font-size: 1.6em;
font-weight: 600;
`

const SubTitle = styled.div`
text-align: left;
width: 100%;
font-size: 1.2em;
font-weight: 600;
padding-bottom: 0.5em;
`

const FlexBox = styled.div`
display: flex;
gap: 2em;
width: 100%;
flex-wrap: wrap;
`

const WhiteBox = styled.div`
background-color: #fff;
width: 100%;
padding: 1em;
`

const ButtonGroup = styled.div`
width: 100%;
display: flex;
gap: 1em;
align-items: flex-start;
`

const Em20 = styled.div`
width: 20em;
`


export default ListItems